export const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-light relative overflow-hidden">
      <div className="text-center relative z-10">
        {/* Spinner */}
        <div className="relative mb-6 inline-flex">
          <div
            className="
              w-12 h-12 rounded-full
              animate-spin
              [background:conic-gradient(from_0deg,theme(colors.purple),theme(colors.blue),transparent_60%)]
              [mask:radial-gradient(farthest-side,transparent_80%,black_61%)]
              opacity-90
            "
          />
        </div>
        
        {/* Loading text */}
        <p className="text-dark-invirtus font-heading font-semibold text-lg tracking-[-0.4px] mb-2">
          Loading...
        </p>
        <p className="text-dark-invirtus/70 font-body font-medium text-sm">
          Please wait while we prepare your experience
        </p>
      </div>
    </div>
  );
}; 